import { useState } from "react";


import "./Delete.css";


const DeletePage = (props) =>
{

  //State
  const [language, setLanguage] = useState("FR");

  if (language === "EN")
    return (
      <div style={styles.container}>
      <input
          type="button"
          className="page_button page_modal_footer_button"
          value={language === "EN" ? "Version Française" : "English Version"}
          style={{ maxWidth: "200px", marginBottom: "20px" }}
          onClick={() => setLanguage(language === "EN" ? "FR" : "EN")}
        />  
        <h1 style={styles.heading}>Delete Your Account Information</h1>

        <p style={styles.paragraph}>
          To permanently delete your personal data, please follow the steps below:
        </p>

        <ol style={styles.list}>
          <li style={styles.listItem}>
            <strong>Compose an email</strong>
            <ul style={styles.subList}>
              <li>
                From the email address registered to your Innovair Solutions account.
              </li>
              <li>
                To: <a href="mailto:info@innovairsolutions.com">info@innovairsolutions.com</a>
              </li>
            </ul>
          </li>

          <li style={styles.listItem}>
            <strong>Subject line</strong>
            <p>Use something clear like: <em>"Request to Delete My Account Information"</em></p>
          </li>

          <li style={styles.listItem}>
            <strong>Email body</strong>
            <p>
              Briefly state that you wish to have Innovair Solutions delete all personal
              information tied to your account. We will verify the request matches your
              registered email before proceeding.
            </p>
          </li>

          <li style={styles.listItem}>
            <strong>What happens next</strong>
            <p>
              Once confirmed, we will <strong>anonymize</strong> your data: all personal identifiers
              (e.g., your name, email address, and other private details) will be replaced with
              random strings so that your information can no longer be linked back to you.
            </p>
          </li>
        </ol>

        <p style={styles.paragraph}>
          If you have any questions, reply to our confirmation email or reach out at{' '}
          <a href="mailto:info@innovairsolutions.com">info@innovairsolutions.com</a>.
        </p>
      </div>
    )

  return (
    <div style={styles.container}>
      <input
          type="button"
          className="page_button page_modal_footer_button"
          value={language === "EN" ? "Version Française" : "English Version"}
          style={{ maxWidth: "200px", marginBottom: "20px" }}
          onClick={() => setLanguage(language === "EN" ? "FR" : "EN")}
        />  
      <h1 style={styles.heading}>Supprimez vos informations de compte</h1>

      <p style={styles.paragraph}>
        Pour supprimer définitivement vos données personnelles, veuillez suivre les étapes ci-dessous :
      </p>

      <ol style={styles.list}>
        <li style={styles.listItem}>
          <strong>Rédigez un email</strong>
          <ul style={styles.subList}>
            <li>
              Depuis l'adresse email associée à votre compte Innovair Solutions.
            </li>
            <li>
              À : <a href="mailto:info@innovairsolutions.com">info@innovairsolutions.com</a>
            </li>
          </ul>
        </li>

        <li style={styles.listItem}>
          <strong>Objet</strong>
          <p>Utilisez un titre clair, par exemple : <em>« Demande de suppression de mes informations »</em></p>
        </li>

        <li style={styles.listItem}>
          <strong>Corps du message</strong>
          <p>
            Expliquez brièvement que vous souhaitez que Innovair Solutions supprime toutes les
            informations personnelles liées à votre compte. Nous vérifierons que la demande provient
            bien de votre adresse email enregistrée avant de procéder.
          </p>
        </li>

        <li style={styles.listItem}>
          <strong>Suite</strong>
          <p>
            Une fois la demande confirmée, nous <strong>anonymiserons</strong> vos données : tous les
            identifiants personnels (par exemple : votre nom, votre adresse email et autres informations
            privées) seront remplacés par des chaînes aléatoires afin que vos données ne puissent plus
            être reliées à vous.
          </p>
        </li>
      </ol>

      <p style={styles.paragraph}>
        Si vous avez des questions, répondez à notre email de confirmation ou contactez-nous à{' '}
        <a href="mailto:info@innovairsolutions.com">info@innovairsolutions.com</a>.
      </p>
    </div>
    );


};

const styles = {
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '2rem',
    fontFamily: 'Arial, sans-serif',
    lineHeight: 1.6,
    color: '#333'
  },
  heading: {
    fontSize: '2rem',
    marginBottom: '1rem',
  },
  paragraph: {
    fontSize: '1rem',
    marginBottom: '1rem',
  },
  list: {
    marginLeft: '1.5rem',
    marginBottom: '1rem',
  },
  listItem: {
    marginBottom: '1rem',
  },
  subList: {
    marginLeft: '1rem',
    marginTop: '0.5rem',
  },
};

export default DeletePage;